module.exports = __webpack_public_path__ + "static/media/ts13cr1023.e85c78ce.png";